const API_BASE = process.env.VUE_APP_BASEURL;

const emptyPurchase = () => ({
  plan: null,
  customer: {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    country: 'Mexico',
    state: '',
    language: 'es',
  },
  quote: null,
  order: null,
  payment: null,
  confirmation: null,
  holders: [],
  activation_mode: 'now',
  activation_date: '',
  quantity: 1,
  coupon_code: '',
});

const state = {
  purchase: emptyPurchase(),
  plans: [],
};

const getters = {
  getPassportPurchase(state) {
    return state.purchase;
  },
  getPassportPlans(state) {
    return state.plans;
  },
};

const mutations = {
  SET_PLANS(state, plans) {
    state.plans = plans || [];
  },
  SET_PURCHASE(state, payload) {
    state.purchase = { ...state.purchase, ...payload };
  },
  SET_CUSTOMER(state, payload) {
    state.purchase.customer = { ...state.purchase.customer, ...payload };
  },
  CLEAR_PURCHASE(state) {
    state.purchase = emptyPurchase();
  },
};

const jsonHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

async function parseResponse(res) {
  const json = await res.json();
  if (!res.ok) {
    return json;
  }
  return json;
}

const actions = {
  clearPassportPurchase({ commit }) {
    commit('CLEAR_PURCHASE');
  },
  updatePassportPurchase({ commit }, payload) {
    commit('SET_PURCHASE', payload);
  },
  updatePassportCustomer({ commit }, payload) {
    commit('SET_CUSTOMER', payload);
  },
  async getPassportPlans({ commit }) {
    const res = await fetch(`${API_BASE}public/passports/plans`, {
      method: 'GET',
      headers: jsonHeaders,
    });
    const response = await parseResponse(res);
    commit('SET_PLANS', response.data || []);
    return response;
  },
  async quotePassportPurchase({ commit }, payload) {
    const res = await fetch(`${API_BASE}public/passports/quote`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload),
    });
    const response = await parseResponse(res);
    if (response.data) {
      commit('SET_PURCHASE', { quote: response.data });
    }
    return response;
  },
  async savePassportCustomer({ commit }, payload) {
    const res = await fetch(`${API_BASE}public/passports/customers`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload),
    });
    const response = await parseResponse(res);
    if (response.data) {
      commit('SET_CUSTOMER', response.data);
    }
    return response;
  },
  async createPassportOrder({ commit }, payload) {
    const res = await fetch(`${API_BASE}public/passports/orders`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload),
    });
    const response = await parseResponse(res);
    if (response.data) {
      commit('SET_PURCHASE', { order: response.data });
    }
    return response;
  },
  async createPassportPaymentIntent({ commit }, payload) {
    const res = await fetch(`${API_BASE}public/passports/payment-intent`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload),
    });
    const response = await parseResponse(res);
    if (response.data) {
      commit('SET_PURCHASE', { payment: response.data });
    }
    return response;
  },
  async confirmPassportPurchase({ commit }, payload) {
    const res = await fetch(`${API_BASE}public/passports/confirm`, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload),
    });
    const response = await parseResponse(res);
    if (response.data) {
      commit('SET_PURCHASE', { confirmation: response.data });
    }
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
